import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useRoadsideServicesVisibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteServicePointRoadsideTypeSelect,
    stationsFilter: !!permissions.servicePointFilterRoadsideTypeSelect
  } as const), [permissions])
};
